/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import TextField from "@material-ui/core/TextField";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import { useAppDispatch, useAppSelector } from "../../useStore";
import { Spinners } from "../TableOptions";
import swal from "sweetalert";
import { reset, sendForHire } from "../../features/Applicant/applicantSlice";
import { FormControl } from "@mui/material";
import moment from "moment";
import ModalHeader from "../ModalHeader";


const HireModal = ({ title, id, name, recruiterID }: any) => {
  const dispatch = useAppDispatch();
  const { sendForHireisSuccess, sendForHireisError, sendForHireisLoading, sendForHiremessage } = useAppSelector((state: any) => state.applicant);
  const [welcome, setWelcome] = useState(false);
  const handleWelcome = () => setWelcome(true);
  const [startingDate, setStartingDate] = useState("");

  const [inputs, setInputs] = useState({
    comment: "",
    startingDate: "",
    recruiterID: "",
    applicationIds: ""
  })



  const handleCloseWelcome = () => {
    setWelcome(false);
    setInputs({
      comment: "",
      startingDate: "",
      recruiterID: "",
      applicationIds: ""
    })
  }

  useEffect(() => {
    if (sendForHireisError) {
      swal({
        title: "error",
        text: sendForHiremessage,
        icon: "error"
      })
      dispatch(reset())
    } else if (sendForHireisSuccess) {
      swal({
        title: "success",
        text: "Application have been Hired",
        icon: "success"
      })
      setInputs({
        comment: "",
        startingDate: "",
        recruiterID: "",
        applicationIds: ""
      })
      setWelcome(false)
      dispatch(reset())
    }
  }, [dispatch, sendForHireisError, sendForHireisSuccess, sendForHiremessage])





  useEffect(() => {
    setInputs((prevState: any) => {
      return ({
        ...prevState,
        recruiterID: recruiterID,
        applicationIds: id
      });
    });
  }, [inputs.applicationIds, setInputs, id]);


  const handleOnChange = (input: any, value: any) => {
    if (input === 'startingDate') {
      setStartingDate(value)
    }
    setInputs((prevState: any) => ({
      ...prevState,
      [input]: input === 'startingDate' ? moment(value).format('DD/MM/YYYY') : value,
    }));
  };

  const handleHire = () => {
    // @ts-ignore
    dispatch(sendForHire(inputs));
  }



  return (
    <div>
      <div onClick={handleWelcome} className="more-button">
        {title}
      </div>
      <Modal show={welcome} onHide={handleCloseWelcome}  >
        <ModalHeader setShow={setWelcome} headerTitle={"Hire"} />
        <Modal.Body>
          <form>
            <div className="applicant-name" >
              <h5>Applicant Name</h5>
              <p>{name}</p>
            </div>
            <div className="schedule-setting" style={{ marginTop: "40px" }}>

              <FormControl fullWidth>
                <h5>Select Joining Date</h5>
                <TextField
                  required
                  id="outlined-basic"
                  name='date'
                  type='date'
                  size="small"
                  style={{ width: "100%", margin: "10px 0" }}
                  variant="outlined"
                  value={startingDate}
                  onChange={(e) => handleOnChange("startingDate", e.target.value)} />
              </FormControl>
            </div>

            <div className="comment" style={{ marginTop: "40px" }}>
              <h5>Comment</h5>
              <TextField
                id="outlined-multiline-static"
                multiline
                fullWidth
                type="text"
                minRows={4}
                variant="outlined"
                style={{ marginTop: "10px" }}
                value={inputs.comment}
                onChange={(e) => handleOnChange("comment", e.target.value)}
              />
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseWelcome}>
            Cancel
          </Button>
          <Button id="primary"
            onClick={handleHire}
            disabled={sendForHireisLoading}>
            {sendForHireisLoading ? <Spinners size={"sm"} /> : "Send"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default HireModal;
